import React, { useState } from "react";
import PreviousBar from "../component/PreviousBar";
import { useDispatch } from "react-redux";
import CancelPresentationSharpIcon from '@mui/icons-material/CancelPresentationSharp';
import { changeTypeToName } from "../helper/changeBankIdtoName";
import { addTicketList } from "../features/lotteryInvoice";
import { useNavigate } from "react-router-dom";


const SetNumber = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Data, setData] = useState({
    setName: '',
    betType: 'bon_6',
    betNumber: '',
  })

  const [ticketList, setticketList] = useState([])

  const onChange = (e) => {
    // console.log(e.target)
    if (e.target.id == "betNumber") {
      // console.log(e.target.value.length)
      if (e.target.value.match(/^[0-9]*$/)) {
        setData({ ...Data, [e.target.id]: e.target.value })
      }
    } else {
      setData({ ...Data, [e.target.id]: e.target.value })
    }
  }

  const addTicket = (length) => {
    let tickets = ticketList
    if (Data.betNumber.length != length) {
      alert('กรุณากรอกตัวเลขให้ตรงตามกำหนด')
    } else {
      tickets.push({ betType: Data.betType, betNumber: Data.betNumber })
      setticketList(tickets)
      setData({ ...Data, betNumber: '' })
    }
  }

  const deleteTicket = (i) => {
    let tickets = [...ticketList]
    tickets.splice(i, 1)
    setticketList(tickets)
    // console.log(`ticketList`, ticketList)
  }

  const saveTicketList = async () => {
    const data = {
      member: localStorage.getItem('member'),
      setName: Data.setName,
      ticketList: ticketList
    }
    const res = await dispatch(addTicketList(data))
    if (res.data.code == '999999') {
    navigate('/betnumset')
    }
  }

  return (

    <div>
      <PreviousBar name="สร้างเลขชุด" />
      <div className="w-full px-3 py-3  h-auto mt-5 border border-gray-300 rounded text-[#b3853e]">
        <div className="w-full border-b pb-3 flex">
          <p>ชื่อชุด</p>
          <input id='setName' onChange={onChange} value={Data.setName} className="w-auto border text-[#b3853e] border-defaultBorder rounded ml-3 outline-none px-3" />
        </div>
        <p className="text-sm my-3">สร้างเลขชุด</p>
        <div className="w-auto grid grid-cols-4 gap-2 md:grid-cols-6 text-[#b3853e]">
          <select id="betType" onChange={onChange} value={Data.betType} className="p-1 rounded border text-base outline-none border-defaultBorder">
            <option value="bon_6">6ตัวบน</option>
            <option value="bon_5">5ตัวบน</option>
            <option value="bon_4">4ตัวบน</option>
            <option value="bon_3">3ตัวบน</option>
            <option value="tode_3">3ตัวโต๊ด</option>
            <option value="na_3">3ตัวหน้า</option>
            <option value="lang_3">3ต้วล่าง</option>
            <option value="bon_2">2ตัวบน</option>
            <option value="lang_2">2ตัวล่าง</option>
            <option value="bon_1">วิ่งบน</option>
            <option value="lang_1">วิ่งล่าง</option>
          </select>
          <input onChange={onChange} value={Data.betNumber} id="betNumber" type="text" maxLength={Data.betType.substr(Data.betType.length - 1)} className="border text-[#b3853e] rounded col-span-2 outline-none md:col-span-4 px-3 border-defaultBorder" />
          <button onClick={() => addTicket(Data.betType.substr(Data.betType.length - 1))} className="text-sm bg-red-500 rounded text-white px-2">
            เพิ่มเลข
          </button>
        </div>

        <div className="w-full h-auto border border-defaultBorder mt-3 rounded">
          <div className="grid grid-cols-5 border-b py-2 text-center text-base">
            <p className="col-span-2">ชนิดหวย</p>
            <p className="col-span-2">เลข</p>
          </div>

          <div className="grid grid-cols-5 border-b text-center text-[#b3853e] text-base py-2">
            {ticketList.length ? ticketList.map((ticket, i) => (
              <>
                <p className="col-span-2 my-1">{changeTypeToName(ticket.betType)}</p>
                <p className="col-span-2 my-1">{ticket.betNumber}</p>
                <button onClick={() => deleteTicket(i)}><CancelPresentationSharpIcon /></button>
              </>
            )) :
              <p className="col-span-5">ไม่มีรายการ</p>
            }
          </div>

        </div>
      </div>
      <div className="flex gird grid-cols-3 gap-5 mt-3 px-10">
        <button onClick={() => setticketList([])} className="border border-[#b3853e] w-full py-2.5 text-center text-[#b3853e] text-base hover:opacity-50 md:px-8"
        >
         ยกเลิก
        </button>
        <button onClick={() => saveTicketList([])} className="border border-[#b3853e] w-full py-2.5 text-center text-[#b3853e] text-base hover:opacity-50 md:px-8"
        >
         บันทึก
        </button>
     
      </div>
    </div>
  );
};

export default SetNumber;
